import React, { useState } from "react";
import styles from "./Franchise.module.css";
import franchise from "../assets/franchise.png";
import IndiaMap from "./IndiaMap";
import { useNavigate } from "react-router-dom";
import { Button, Image } from "react-bootstrap";

export default function Franchise() {
  const [stateCode, setStateCode] = useState("");
  const [stateName, setStateName] = useState("");

  function onLocationClick(event) {
    setStateCode(event.target.id);
    setStateName(event.target.getAttribute("name"));
    // console.log(event.target);
    console.log("Id", event.target.id);
    console.log("Name", event.target.getAttribute("name"));
  }
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/franchiseHome");
  };

  return (
    <div className={styles.containerFranchise}>
      <div className={styles.rowFranchise}>
        <div className={styles.col1Franchise}>
          <div className={styles.col1FranchiseMini}>
            <h1 className={styles.franchtest}>
              Apply as Our Franchise Partner Franchise
            </h1>
            {/* <h3 className={styles.franchtest1}>
              Become <br></br> A Franchise
            </h3> */}
            {/* <h3 className={styles.franchtest1}>
              Become  A Franchise
            </h3> */}
            <br></br>
            <p className={styles.franchtest2}>
              Join us as a franchise partner and be part of our success story.</p>
            <p className={styles.franchtest2}  >
              Enjoy exclusive benefits, comprehensive support, and a proven business model.</p>
            <ul>
              <ul >
                <li>Get Everyday Exclusive Orders</li>
                <li>Earn More Revenue</li>
                <li>Access to Proven Business Model</li>
                <li>Comprehensive Training & Support</li>
                <li>Strong Brand Recognition</li>
                <li>Marketing & Advertising Assistance</li>
                <li>Low Risk, High Growth Opportunity</li>
                <li>Exclusive Territory Rights</li>
                <li>Ongoing Operational Guidance</li>
                <li>Bulk Purchasing Power & Discounts</li>
              </ul>
            </ul>
            <br></br>
            <p className={styles.franchtest2}>
              Ready to take the next step? Click the button below to apply now!
            </p>
            <Button className={styles.franchBtn} onClick={handleClick} style={{marginBottom:20}}>
              APPLY
            </Button>
          </div>
        </div>
        <div className={styles.col2Franchise}>
          <div className={styles.mapContainer}>
            {/* <IndiaMap /> */}
            <Image
              src={franchise}
              style={{ width: "100%", height:550 ,}}
            />
          </div>

          {/*             
            <ComposableMap projection="geoMercator"   projectionConfig={{
       
        scale: 500
      }} >
      <Geographies geography={geoUrl} style={{width:500,height:500}}>
        {({ geographies }) =>
          geographies.map((geo) => (
            <Geography
              key={geo.rsmKey}
              geography={geo}
            
            />
          ))
        }
      </Geographies>
 
    </ComposableMap> */}
        </div>
      </div>

      <div className={styles.franchesmobile}>
        <h3 className={styles.franchtest1}>Become A Franchise</h3>
        <br></br>
        <div style={{ display: "flex" }}>
          <div className={styles.frachesmobileCol1}>
            <h1 className={styles.franchtest}>Our Franchise</h1>

            <ul className={styles.lists}>
              <li>Get Everyday Exclusive Orders</li>
              <li>Earn More Revenue</li>
            </ul>
            <button className={styles.franchBtn} onClick={() => handleClick()}>
              APPLY
            </button>
          </div>
          <div className={styles.frachesmobileCol2}>
            <IndiaMap />
          </div>
        </div>
      </div>
    </div>
  );
}
